/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  AdditionalScoringDetailsDTO,
  ContestantAttributesModel,
  ContestantComprehensiveTabulationAreaOfCompetitionResult,
  ContestantComprehensiveTabulationResultNew,
  ContestantCriteriaSetting,
  ContestantRegistrationDetailsDTO,
  ContestantSupremeScoreResultOptimized,
  GeneralScoringCriteriaSettings,
  MaxPossibleResponse,
  ProblemDetails,
  RegistrationInvoice,
  SpecificAwardFullCriteria,
  StaffTabulatorAccessCodesDTO,
  SupremeScoreResult,
  TabulationStatusDTO,
} from './data-contracts';
import { ContentType, HttpClient, RequestParams } from './http-client';

export class Tabulation<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags Tabulation
   * @name FinishSideAwardsPageantDivisionCreate
   * @request POST:/Tabulation/FinishSideAwards/Pageant:{pageantId}/Division:{divisionId}
   */
  finishSideAwardsPageantDivisionCreate = (
    pageantId: number,
    divisionId: number,
    query?: {
      /** @format int32 */
      ageGroupId?: number;
    },
    params: RequestParams = {}
  ) =>
    this.request<void, any>({
      path: `/Tabulation/FinishSideAwards/Pageant:${pageantId}/Division:${divisionId}`,
      method: 'POST',
      query: query,
      ...params,
    });
  /**
   * No description
   *
   * @tags Tabulation
   * @name GetPageantAvailableAocDynamically
   * @request GET:/Tabulation/GetPageantAvailableAOCDynamically
   */
  getPageantAvailableAocDynamically = (
    query?: {
      /** @format int32 */
      pageantId?: number;
      /** @format int32 */
      aocId?: number;
      /** @format int32 */
      aocTypeId?: number;
      /** @format int32 */
      registeredPageantContestantId?: number;
      /** @format int32 */
      pageantAvailablePackageId?: number;
    },
    params: RequestParams = {}
  ) =>
    this.request<void, any>({
      path: `/Tabulation/GetPageantAvailableAOCDynamically`,
      method: 'GET',
      query: query,
      ...params,
    });
  /**
   * No description
   *
   * @tags Tabulation
   * @name GetPageantAvailableAwardsDynamically
   * @request GET:/Tabulation/GetPageantAvailableAwardsDynamically
   */
  getPageantAvailableAwardsDynamically = (
    query?: {
      /** @format int32 */
      pageantId?: number;
      /** @format int32 */
      titleId?: number;
      /** @format int32 */
      awardTypeId?: number;
      /** @format int32 */
      registeredPageantContestantId?: number;
      /** @format int32 */
      pageantAvailablePackageId?: number;
    },
    params: RequestParams = {}
  ) =>
    this.request<void, any>({
      path: `/Tabulation/GetPageantAvailableAwardsDynamically`,
      method: 'GET',
      query: query,
      ...params,
    });
  /**
   * No description
   *
   * @tags Tabulation
   * @name TabulationGetAwardRelationshipRecordsDynamically
   * @request GET:/Tabulation/TabulationGetAwardRelationshipRecordsDynamically
   */
  tabulationGetAwardRelationshipRecordsDynamically = (
    query?: {
      /** @format int32 */
      registeredContestantId?: number;
      /** @format int32 */
      pageantAvailableTitleId?: number;
      /** @format int32 */
      pageantId?: number;
    },
    params: RequestParams = {}
  ) =>
    this.request<void, any>({
      path: `/Tabulation/TabulationGetAwardRelationshipRecordsDynamically`,
      method: 'GET',
      query: query,
      ...params,
    });
  /**
   * No description
   *
   * @tags Tabulation
   * @name TabulationSyncAwardRelationshipRecordsDynamically
   * @request POST:/Tabulation/TabulationSyncAwardRelationshipRecordsDynamically
   */
  tabulationSyncAwardRelationshipRecordsDynamically = (
    query?: {
      /** @format int32 */
      registeredContestantId?: number;
      /** @format int32 */
      pageantAvailableTitleId?: number;
      /** @format int32 */
      pageantId?: number;
      pruneExtraAwardIndexes?: boolean;
    },
    params: RequestParams = {}
  ) =>
    this.request<Record<string, number>, ProblemDetails | void>({
      path: `/Tabulation/TabulationSyncAwardRelationshipRecordsDynamically`,
      method: 'POST',
      query: query,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Tabulation
   * @name GetReceivedScoresDynamically
   * @request GET:/Tabulation/GetReceivedScoresDynamically
   */
  getReceivedScoresDynamically = (
    query?: {
      /** @format int32 */
      pageantId?: number;
      /** @format int32 */
      registeredPageantContestantId?: number;
      /** @format int32 */
      judgeId?: number;
      /** @format int32 */
      aocId?: number;
      /** @format int32 */
      aocScoringCategoryId?: number;
    },
    params: RequestParams = {}
  ) =>
    this.request<void, any>({
      path: `/Tabulation/GetReceivedScoresDynamically`,
      method: 'GET',
      query: query,
      ...params,
    });
  /**
   * No description
   *
   * @tags Tabulation
   * @name HasAnyScores
   * @request GET:/Tabulation/HasAnyScores
   */
  hasAnyScores = (
    query?: {
      /** @format int32 */
      pageantId?: number;
      /** @format int32 */
      registeredPageantContestantId?: number;
      /** @format int32 */
      judgeId?: number;
      /** @format int32 */
      aocId?: number;
      /** @format int32 */
      aocScoringCategoryId?: number;
    },
    params: RequestParams = {}
  ) =>
    this.request<void, any>({
      path: `/Tabulation/HasAnyScores`,
      method: 'GET',
      query: query,
      ...params,
    });
  /**
   * No description
   *
   * @tags Tabulation
   * @name GetScoreCount
   * @request GET:/Tabulation/GetScoreCount
   */
  getScoreCount = (
    query?: {
      /** @format int32 */
      pageantId?: number;
      /** @format int32 */
      registeredPageantContestantId?: number;
      /** @format int32 */
      judgeId?: number;
      /** @format int32 */
      aocId?: number;
      /** @format int32 */
      aocScoringCategoryId?: number;
    },
    params: RequestParams = {}
  ) =>
    this.request<void, any>({
      path: `/Tabulation/GetScoreCount`,
      method: 'GET',
      query: query,
      ...params,
    });
  /**
   * No description
   *
   * @tags Tabulation
   * @name TabulationGetAwardWinnersDynamically
   * @request GET:/Tabulation/TabulationGetAwardWinnersDynamically
   */
  tabulationGetAwardWinnersDynamically = (
    query?: {
      /** @format int32 */
      pageantId?: number;
      /** @format int32 */
      registeredContestantId?: number;
      /** @format int32 */
      pageantAvailableTitleId?: number;
      /** @format int32 */
      awardTypeId?: number;
      /** @format int32 */
      ageGroupId?: number;
    },
    params: RequestParams = {}
  ) =>
    this.request<void, any>({
      path: `/Tabulation/TabulationGetAwardWinnersDynamically`,
      method: 'GET',
      query: query,
      ...params,
    });
  /**
   * No description
   *
   * @tags Tabulation
   * @name GetTotalScoresForContestantByAocDetail
   * @request GET:/Tabulation/GetTotalScoresForContestantByAOC:{contestantId}
   */
  getTotalScoresForContestantByAocDetail = (contestantId: number, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/Tabulation/GetTotalScoresForContestantByAOC:${contestantId}`,
      method: 'GET',
      ...params,
    });
  /**
   * No description
   *
   * @tags Tabulation
   * @name GetTotalScoresWithDropScoreLogicForContestantByAocPageantIdContestantIdDetail
   * @request GET:/Tabulation/GetTotalScoresWithDropScoreLogicForContestantByAOC/pageantId:{pageantId}/contestantId:{contestantId}
   */
  getTotalScoresWithDropScoreLogicForContestantByAocPageantIdContestantIdDetail = (pageantId: number, contestantId: number, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/Tabulation/GetTotalScoresWithDropScoreLogicForContestantByAOC/pageantId:${pageantId}/contestantId:${contestantId}`,
      method: 'GET',
      ...params,
    });
  /**
   * No description
   *
   * @tags Tabulation
   * @name GetUsedAoCsForSupremeScorePageantIdContestantIdDetail
   * @request GET:/Tabulation/GetUsedAOCsForSupremeScore/pageantId:{pageantId}/contestantId:{contestantId}
   */
  getUsedAoCsForSupremeScorePageantIdContestantIdDetail = (pageantId: number, contestantId: number, params: RequestParams = {}) =>
    this.request<SupremeScoreResult, any>({
      path: `/Tabulation/GetUsedAOCsForSupremeScore/pageantId:${pageantId}/contestantId:${contestantId}`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Tabulation
   * @name GetComprehensiveAocScoresForContestantDetail
   * @request GET:/Tabulation/GetComprehensiveAOCScoresForContestant/{pageantId}/{contestantId}
   */
  getComprehensiveAocScoresForContestantDetail = (pageantId: number, contestantId: number, params: RequestParams = {}) =>
    this.request<ContestantComprehensiveTabulationAreaOfCompetitionResult, any>({
      path: `/Tabulation/GetComprehensiveAOCScoresForContestant/${pageantId}/${contestantId}`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Tabulation
   * @name GetComprehensiveAwardsDetailsForContestantPageantIdContestantIdDetail
   * @request GET:/Tabulation/GetComprehensiveAwardsDetailsForContestant/pageantId:{pageantId}/contestantId:{contestantId}
   */
  getComprehensiveAwardsDetailsForContestantPageantIdContestantIdDetail = (pageantId: number, contestantId: number, params: RequestParams = {}) =>
    this.request<ContestantComprehensiveTabulationResultNew, any>({
      path: `/Tabulation/GetComprehensiveAwardsDetailsForContestant/pageantId:${pageantId}/contestantId:${contestantId}`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Tabulation
   * @name GetComprehensiveTabulationDetailsForContestantPageantIdContestantIdDetail
   * @request GET:/Tabulation/GetComprehensiveTabulationDetailsForContestant/pageantId:{pageantId}/contestantId:{contestantId}
   */
  getComprehensiveTabulationDetailsForContestantPageantIdContestantIdDetail = (pageantId: number, contestantId: number, params: RequestParams = {}) =>
    this.request<ContestantComprehensiveTabulationResultNew, any>({
      path: `/Tabulation/GetComprehensiveTabulationDetailsForContestant/pageantId:${pageantId}/contestantId:${contestantId}`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Tabulation
   * @name DynamicComprehensiveTabulationsList
   * @request GET:/Tabulation/DynamicComprehensiveTabulations
   */
  dynamicComprehensiveTabulationsList = (
    query?: {
      /** @format int32 */
      pageantId?: number;
      registeredContestantIds?: number[];
    },
    params: RequestParams = {}
  ) =>
    this.request<ContestantComprehensiveTabulationResultNew[], any>({
      path: `/Tabulation/DynamicComprehensiveTabulations`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Tabulation
   * @name GetAllRegisteredContestantsAttributes
   * @request GET:/Tabulation/GetAllRegisteredContestantsAttributes/PageantId:{pageantId}
   */
  getAllRegisteredContestantsAttributes = (pageantId: number, params: RequestParams = {}) =>
    this.request<ContestantAttributesModel[], any>({
      path: `/Tabulation/GetAllRegisteredContestantsAttributes/PageantId:${pageantId}`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Tabulation
   * @name GetAllRegisteredContestantsAttributesV2
   * @request GET:/Tabulation/GetAllRegisteredContestantsAttributesV2/PageantId:{pageantId}
   */
  getAllRegisteredContestantsAttributesV2 = (pageantId: number, params: RequestParams = {}) =>
    this.request<ContestantAttributesModel[], any>({
      path: `/Tabulation/GetAllRegisteredContestantsAttributesV2/PageantId:${pageantId}`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Tabulation
   * @name GetRegisteredContestantAttributes
   * @request GET:/Tabulation/GetRegisteredContestantAttributes/Pageant:{pageantId}/contestant/{registeredContestantId}
   */
  getRegisteredContestantAttributes = (pageantId: number, registeredContestantId: number, params: RequestParams = {}) =>
    this.request<ContestantAttributesModel, any>({
      path: `/Tabulation/GetRegisteredContestantAttributes/Pageant:${pageantId}/contestant/${registeredContestantId}`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Tabulation
   * @name GetRegisteredContestantRegistrationInvoice
   * @request GET:/Tabulation/GetRegisteredContestantRegistrationInvoice/Pageant:{pageantId}/contestant/{registeredContestantId}
   */
  getRegisteredContestantRegistrationInvoice = (pageantId: number, registeredContestantId: number, params: RequestParams = {}) =>
    this.request<RegistrationInvoice, any>({
      path: `/Tabulation/GetRegisteredContestantRegistrationInvoice/Pageant:${pageantId}/contestant/${registeredContestantId}`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Tabulation
   * @name GetContestantRegistrationDetails
   * @request GET:/Tabulation/GetContestantRegistrationDetails/Pageant:{pageantId}/contestant/{registeredContestantId}
   */
  getContestantRegistrationDetails = (pageantId: number, registeredContestantId: number, params: RequestParams = {}) =>
    this.request<ContestantRegistrationDetailsDTO, any>({
      path: `/Tabulation/GetContestantRegistrationDetails/Pageant:${pageantId}/contestant/${registeredContestantId}`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Tabulation
   * @name GetStaffTabulatorAccessCodes
   * @request GET:/Tabulation/GetStaffTabulatorAccessCodes/Pageant:{pageantId}
   */
  getStaffTabulatorAccessCodes = (pageantId: number, params: RequestParams = {}) =>
    this.request<StaffTabulatorAccessCodesDTO, any>({
      path: `/Tabulation/GetStaffTabulatorAccessCodes/Pageant:${pageantId}`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Tabulation
   * @name GetSupremeScoringCriteriaDetail
   * @request GET:/Tabulation/GetSupremeScoringCriteria/{pageantId}
   */
  getSupremeScoringCriteriaDetail = (pageantId: number, params: RequestParams = {}) =>
    this.request<GeneralScoringCriteriaSettings, any>({
      path: `/Tabulation/GetSupremeScoringCriteria/${pageantId}`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Tabulation
   * @name CalculateAndSaveSupremeScoresCreate
   * @request POST:/Tabulation/CalculateAndSaveSupremeScores/{pageantId}
   */
  calculateAndSaveSupremeScoresCreate = (pageantId: number, params: RequestParams = {}) =>
    this.request<ContestantSupremeScoreResultOptimized, any>({
      path: `/Tabulation/CalculateAndSaveSupremeScores/${pageantId}`,
      method: 'POST',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Tabulation
   * @name GetContestantSupremeScoreGetContestantSupremeScoreByContestantIdPageantIdDetail
   * @request GET:/Tabulation/GetContestantSupremeScore/GetContestantSupremeScoreByContestantId:{contestantId}_PageantId:{pageantId}
   */
  getContestantSupremeScoreGetContestantSupremeScoreByContestantIdPageantIdDetail = (contestantId: number, pageantId: number, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/Tabulation/GetContestantSupremeScore/GetContestantSupremeScoreByContestantId:${contestantId}_PageantId:${pageantId}`,
      method: 'GET',
      ...params,
    });
  /**
   * No description
   *
   * @tags Tabulation
   * @name SaveSupremeScoringCriteriaCreate
   * @request POST:/Tabulation/SaveSupremeScoringCriteria
   */
  saveSupremeScoringCriteriaCreate = (
    data: GeneralScoringCriteriaSettings,
    query?: {
      /** @format int32 */
      pageantId?: number;
    },
    params: RequestParams = {}
  ) =>
    this.request<void, any>({
      path: `/Tabulation/SaveSupremeScoringCriteria`,
      method: 'POST',
      query: query,
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Tabulation
   * @name ResetAwardScoringCriteriaForPageantCreate
   * @request POST:/Tabulation/ResetAwardScoringCriteriaForPageant
   */
  resetAwardScoringCriteriaForPageantCreate = (
    query?: {
      /** @format int32 */
      pageantId?: number;
    },
    params: RequestParams = {}
  ) =>
    this.request<void, any>({
      path: `/Tabulation/ResetAwardScoringCriteriaForPageant`,
      method: 'POST',
      query: query,
      ...params,
    });
  /**
   * No description
   *
   * @tags Tabulation
   * @name ResetAwardScoringCriteriaDynamicCreate
   * @request POST:/Tabulation/ResetAwardScoringCriteriaDynamic
   */
  resetAwardScoringCriteriaDynamicCreate = (
    query?: {
      /** @format int32 */
      pageantId?: number;
      pageantAvailableTitleIds?: number[];
    },
    params: RequestParams = {}
  ) =>
    this.request<void, any>({
      path: `/Tabulation/ResetAwardScoringCriteriaDynamic`,
      method: 'POST',
      query: query,
      ...params,
    });
  /**
   * No description
   *
   * @tags Tabulation
   * @name AddOrEditAwardScoringCriteria
   * @request POST:/Tabulation/AddOrEditAwardScoringCriteria
   */
  addOrEditAwardScoringCriteria = (
    data: GeneralScoringCriteriaSettings,
    query?: {
      /** @format int32 */
      awardId?: number;
    },
    params: RequestParams = {}
  ) =>
    this.request<void, any>({
      path: `/Tabulation/AddOrEditAwardScoringCriteria`,
      method: 'POST',
      query: query,
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Tabulation
   * @name AddEditScoringCriteria
   * @request POST:/Tabulation/AddEditScoringCriteria
   */
  addEditScoringCriteria = (
    data: GeneralScoringCriteriaSettings,
    query?: {
      /** @format int32 */
      awardId?: number;
    },
    params: RequestParams = {}
  ) =>
    this.request<void, any>({
      path: `/Tabulation/AddEditScoringCriteria`,
      method: 'POST',
      query: query,
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Tabulation
   * @name SaveAwardScoringCriteriaCreate
   * @request POST:/Tabulation/SaveAwardScoringCriteria
   */
  saveAwardScoringCriteriaCreate = (
    data: GeneralScoringCriteriaSettings,
    query?: {
      /** @format int32 */
      awardId?: number;
    },
    params: RequestParams = {}
  ) =>
    this.request<void, any>({
      path: `/Tabulation/SaveAwardScoringCriteria`,
      method: 'POST',
      query: query,
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Tabulation
   * @name SaveAwardContestantCriteriaCreate
   * @request POST:/Tabulation/SaveAwardContestantCriteria
   */
  saveAwardContestantCriteriaCreate = (
    data: ContestantCriteriaSetting[],
    query?: {
      /** @format int32 */
      awardId?: number;
    },
    params: RequestParams = {}
  ) =>
    this.request<void, any>({
      path: `/Tabulation/SaveAwardContestantCriteria`,
      method: 'POST',
      query: query,
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Tabulation
   * @name SaveAwardFullCriteria
   * @request POST:/Tabulation/SaveAwardFullCriteria
   */
  saveAwardFullCriteria = (
    data: SpecificAwardFullCriteria,
    query?: {
      /** @format int32 */
      awardId?: number;
    },
    params: RequestParams = {}
  ) =>
    this.request<void, any>({
      path: `/Tabulation/SaveAwardFullCriteria`,
      method: 'POST',
      query: query,
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Tabulation
   * @name SaveAdditionalScoringDetailsCreate
   * @request POST:/Tabulation/SaveAdditionalScoringDetails
   */
  saveAdditionalScoringDetailsCreate = (data: AdditionalScoringDetailsDTO, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/Tabulation/SaveAdditionalScoringDetails`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Tabulation
   * @name SaveUseSupremeScoringCriteriaForAward
   * @request POST:/Tabulation/SaveUseSupremeScoringCriteriaForAward/{awardId}
   */
  saveUseSupremeScoringCriteriaForAward = (
    awardId: number,
    data: boolean,
    query?: {
      /** @format int32 */
      pageantId?: number;
    },
    params: RequestParams = {}
  ) =>
    this.request<void, any>({
      path: `/Tabulation/SaveUseSupremeScoringCriteriaForAward/${awardId}`,
      method: 'POST',
      query: query,
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Tabulation
   * @name GetSelectedAocBreakdownBasedOnCriteriaAwardIdContestantIdDetail
   * @request GET:/Tabulation/GetSelectedAOCBreakdownBasedOnCriteria/awardId:{awardId}/contestantId:{contestantId}
   */
  getSelectedAocBreakdownBasedOnCriteriaAwardIdContestantIdDetail = (awardId: number, contestantId: number, params: RequestParams = {}) =>
    this.request<any, ProblemDetails>({
      path: `/Tabulation/GetSelectedAOCBreakdownBasedOnCriteria/awardId:${awardId}/contestantId:${contestantId}`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Tabulation
   * @name GetSelectedAocBreakdownBasedOnCriteriaDetailedAwardIdContestantIdDetail
   * @request GET:/Tabulation/GetSelectedAOCBreakdownBasedOnCriteriaDetailed/awardId:{awardId}/contestantId:{contestantId}
   */
  getSelectedAocBreakdownBasedOnCriteriaDetailedAwardIdContestantIdDetail = (awardId: number, contestantId: number, params: RequestParams = {}) =>
    this.request<any, any>({
      path: `/Tabulation/GetSelectedAOCBreakdownBasedOnCriteriaDetailed/awardId:${awardId}/contestantId:${contestantId}`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Tabulation
   * @name TabulationUpdateEligibilityFlagsDynamicallyCreate
   * @request POST:/Tabulation/TabulationUpdateEligibilityFlagsDynamically
   */
  tabulationUpdateEligibilityFlagsDynamicallyCreate = (
    query?: {
      /** @format int32 */
      pageantId?: number;
      /** @format int32 */
      registeredContestantId?: number;
      /** @format int32 */
      pageantAvailableTitleId?: number;
    },
    params: RequestParams = {}
  ) =>
    this.request<void, ProblemDetails | void>({
      path: `/Tabulation/TabulationUpdateEligibilityFlagsDynamically`,
      method: 'POST',
      query: query,
      ...params,
    });
  /**
   * No description
   *
   * @tags Tabulation
   * @name GetMaxPossiblePointsPerAward
   * @request GET:/Tabulation/GetMaxPossiblePointsPerAward
   */
  getMaxPossiblePointsPerAward = (
    query?: {
      /** @format int32 */
      pageantId?: number;
      /** @format int32 */
      awardId?: number;
    },
    params: RequestParams = {}
  ) =>
    this.request<MaxPossibleResponse, any>({
      path: `/Tabulation/GetMaxPossiblePointsPerAward`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Tabulation
   * @name TabulationCalculateContestantTitleScore
   * @request GET:/Tabulation/Calculate-Contestant-Title-Score/RegisteredContestantId:{contestantId}/TitleId:{titleId}
   */
  tabulationCalculateContestantTitleScore = (contestantId: number, titleId: number, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/Tabulation/Calculate-Contestant-Title-Score/RegisteredContestantId:${contestantId}/TitleId:${titleId}`,
      method: 'GET',
      ...params,
    });
  /**
   * No description
   *
   * @tags Tabulation
   * @name TabulationCalculateContestantTitleScoreDetailed
   * @request GET:/Tabulation/Calculate-Contestant-Title-Score-Detailed/RegisteredContestantId:{contestantId}/TitleId:{titleId}
   */
  tabulationCalculateContestantTitleScoreDetailed = (contestantId: number, titleId: number, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/Tabulation/Calculate-Contestant-Title-Score-Detailed/RegisteredContestantId:${contestantId}/TitleId:${titleId}`,
      method: 'GET',
      ...params,
    });
  /**
   * No description
   *
   * @tags Tabulation
   * @name CalculateContestantTitleScoreFastRegisteredContestantIdTitleIdDetail
   * @request GET:/Tabulation/Calculate-Contestant-Title-Score-Fast/RegisteredContestantId:{contestantId}/TitleId:{titleId}
   */
  calculateContestantTitleScoreFastRegisteredContestantIdTitleIdDetail = (contestantId: number, titleId: number, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/Tabulation/Calculate-Contestant-Title-Score-Fast/RegisteredContestantId:${contestantId}/TitleId:${titleId}`,
      method: 'GET',
      ...params,
    });
  /**
   * No description
   *
   * @tags Tabulation
   * @name TabulationCalculateAwardScoresDynamically
   * @request GET:/Tabulation/CalculateAwardScoresDynamically
   */
  tabulationCalculateAwardScoresDynamically = (
    query?: {
      /** @format int32 */
      registeredContestantId?: number;
      /** @format int32 */
      pageantAvailableTitleId?: number;
      /** @format int32 */
      pageantId?: number;
    },
    params: RequestParams = {}
  ) =>
    this.request<void, any>({
      path: `/Tabulation/CalculateAwardScoresDynamically`,
      method: 'GET',
      query: query,
      ...params,
    });
  /**
   * No description
   *
   * @tags Tabulation
   * @name PinPointCalculateAndSaveAwardScores
   * @request GET:/Tabulation/PinPointCalculateAndSaveAwardScores
   */
  pinPointCalculateAndSaveAwardScores = (
    query?: {
      registeredContestantIds?: number[];
      pageantAvailableTitleIds?: number[];
      /** @format int32 */
      pageantId?: number;
    },
    params: RequestParams = {}
  ) =>
    this.request<void, any>({
      path: `/Tabulation/PinPointCalculateAndSaveAwardScores`,
      method: 'GET',
      query: query,
      ...params,
    });
  /**
   * No description
   *
   * @tags Tabulation
   * @name PinPointCalculateAndSaveAwardScoresFast
   * @request POST:/Tabulation/PinPointCalculateAndSaveAwardScoresFast
   */
  pinPointCalculateAndSaveAwardScoresFast = (
    query?: {
      registeredContestantIds?: number[];
      pageantAvailableTitleIds?: number[];
      /** @format int32 */
      pageantId?: number;
    },
    params: RequestParams = {}
  ) =>
    this.request<void, any>({
      path: `/Tabulation/PinPointCalculateAndSaveAwardScoresFast`,
      method: 'POST',
      query: query,
      ...params,
    });
  /**
   * No description
   *
   * @tags Tabulation
   * @name ApplySupremeScoresCreate
   * @request POST:/Tabulation/apply-supreme-scores
   */
  applySupremeScoresCreate = (
    query?: {
      /** @format int32 */
      pageantId?: number;
      /** @format int32 */
      registeredContestantId?: number;
      /** @format int32 */
      pageantAvailableTitleId?: number;
    },
    params: RequestParams = {}
  ) =>
    this.request<void, any>({
      path: `/Tabulation/apply-supreme-scores`,
      method: 'POST',
      query: query,
      ...params,
    });
  /**
   * No description
   *
   * @tags Tabulation
   * @name TabulationResetAwardScoresDynamically
   * @request POST:/Tabulation/ResetAwardScoresDynamically
   */
  tabulationResetAwardScoresDynamically = (
    query?: {
      /** @format int32 */
      pageantId?: number;
      pageantAvailableTitleIds?: number[];
      registeredContestantIds?: number[];
    },
    params: RequestParams = {}
  ) =>
    this.request<void, ProblemDetails | void>({
      path: `/Tabulation/ResetAwardScoresDynamically`,
      method: 'POST',
      query: query,
      ...params,
    });
  /**
   * No description
   *
   * @tags Tabulation
   * @name UploadResultsPdf
   * @request POST:/Tabulation/UploadResultsPdf/Pageant:{pageantId}
   */
  uploadResultsPdf = (
    pageantId: number,
    data: {
      /** @format binary */
      file?: File;
    },
    params: RequestParams = {}
  ) =>
    this.request<string, any>({
      path: `/Tabulation/UploadResultsPdf/Pageant:${pageantId}`,
      method: 'POST',
      body: data,
      type: ContentType.FormData,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Tabulation
   * @name StatusDetail
   * @request GET:/Tabulation/status/{pageantId}
   */
  statusDetail = (pageantId: number, params: RequestParams = {}) =>
    this.request<TabulationStatusDTO, ProblemDetails | void>({
      path: `/Tabulation/status/${pageantId}`,
      method: 'GET',
      format: 'json',
      ...params,
    });
}
